import React from 'react';
import { IonIcon, IonButton, IonImg, IonText } from '@ionic/react';
import Price from '../Price';
import { cartOutline as cart } from 'ionicons/icons';
import { getDiscount } from './Item';
import './promotions-grid.css';

const GridItem = ({ prod, history, addProductToCart, options }) => {
  const discount = getDiscount(prod);
  const openProduct = () => history.push(`/app/product/${prod.codice_ministeriale}`);

  return (
    <div className="promotion-grid-item">
      {prod.prezzo_bancadati > prod.prezzo && <span className="promotion-grid-badge">-{discount}%</span>}

      <div className="promotion-grid-image" onClick={openProduct}>
        <IonImg
          src={
            prod.immagine && prod.immagine !== ''
              ? `https://static.fogliettoillustrativo.net/ws/it/${prod.immagine}`
              : `/assets/prodotto_generico_125.png`
          }
        />
      </div>

      <div className="promotion-grid-body" onClick={openProduct}>
        <h3 className="ion-text-capitalize">{prod.nome_prodotto}</h3>
        <p className="ion-text-capitalize">{prod.descrizione_ditta_1_produttrice}</p>
      </div>

      <div className="promotion-grid-footer">
        <div className="price">
          <IonText color="success">
            <Price price={prod.prezzo} />
            <span className="euro-symbol">€</span>
          </IonText>
          {prod.prezzo_bancadati > prod.prezzo && (
            <span className="mainprice">
              <Price price={prod.prezzo_bancadati} />
              <span className="euro-symbol">€</span>
            </span>
          )}
        </div>

        {options?.buy_products_in_app === '1' && (
          <IonButton
            color="light"
            size="small"
            onClick={() => addProductToCart(prod.codice_ministeriale, prod.nome_prodotto)}
          >
            <IonIcon slot="icon-only" icon={cart} />
          </IonButton>
        )}
      </div>
    </div>
  );
};

export default GridItem;
